var map = {
	"./RabbitMQ.svg": "c97f",
	"./TiDB.svg": "970a",
	"./angular.svg": "43e5",
	"./go.svg": "b75e",
	"./influxDB.svg": "f538",
	"./js.svg": "9a38",
	"./mariaDB.svg": "247c",
	"./react.svg": "4c91",
	"./ts.svg": "394e",
	"./vue.svg": "fb2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be97";